import { render, staticRenderFns } from "./ChicksAdd.vue?vue&type=template&id=0411d2b4&scoped=true&"
import script from "./ChicksAdd.vue?vue&type=script&lang=js&"
export * from "./ChicksAdd.vue?vue&type=script&lang=js&"
import style0 from "./ChicksAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0411d2b4",
  null
  
)

export default component.exports